import { render, staticRenderFns } from "./fingerprintCollection.vue?vue&type=template&id=1d5dd82c&scoped=true&"
import script from "./fingerprintCollection.vue?vue&type=script&lang=js&"
export * from "./fingerprintCollection.vue?vue&type=script&lang=js&"
import style0 from "./fingerprintCollection.vue?vue&type=style&index=0&id=1d5dd82c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5dd82c",
  null
  
)

export default component.exports